var map = {
	"./Identity-Pattern1.jpg": "1359",
	"./Identity-Pattern1.svg": "9cef",
	"./Identity-Pattern2.jpg": "3fda",
	"./Identity-Pattern2.svg": "ea4d",
	"./Identity-Pattern3.jpg": "2e4a",
	"./Identity-Pattern3.svg": "53df",
	"./Identity-Pattern4.jpg": "95d9",
	"./Identity-Pattern4.svg": "9561",
	"./Identity-Pattern5.jpg": "acd3",
	"./Identity-Pattern5.svg": "3df4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d26c";